"use client";

import { useState, useMemo } from "react";
import ServicesSlugPage from "@/pages/ServicesSlugPage/ServicesSlugPage";
import { User } from "@/types/types";

interface ProfessionalsPageProps {
    users: User[];
    locale: "pt" | "en";
}

export default function ProfessionalsPage({ users, locale }: ProfessionalsPageProps) {
    const [searchQuery, setSearchQuery] = useState("");

    const filteredUsers = useMemo(() => {
        return (users ?? []).filter((user) =>
            user.fullName.toLowerCase().includes(searchQuery.toLowerCase())
        );
    }, [users, searchQuery]);

    if (!users) {
        return <p className="text-center text-gray-500">Loading professionals...</p>;
    }


    return (
        <div className="w-full">
            <div className="flex items-center gap-3 mb-10 px-5">
                <input
                    type="text"
                    placeholder={locale === "pt" ? "Buscar por nome..." : "Search by name..."}
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    className="flex-1 bg-white px-4 py-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-[#77A885]"
                />
            </div>

            <ServicesSlugPage
                locale={locale}
                title={locale === "pt" ? "Todos os Profissionais" : "All Professionals"}
                slug="professionals"
                users={filteredUsers}
            />
        </div>
    );
}
